import { Autocomplete, TextField, Typography } from "@mui/material";
import React, { useState, useEffect } from "react";
import { DeleteConfirmation } from "../../../common/GenericDeleteConfirmationDialog/DeleteConfirmationDialog";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/reducers";
import { useData } from "@pure-ptr/react";
import {
    getRCMTeamDependencies,
    deleteRcmTeam,
} from "../../../store/api/rcmAssignment";
import { DependentsList } from "../../../common";
import { errorToastify } from "../../../util/toast";

const RcmDeleteDependencyDialog = ({
    handleClose,
    handleRefresh,
    rcmAssignmentData,
}) => {
    const dialog: any = useSelector<RootState>(
        (state) => state?.rcmAssignment?.rcmAssignmentDeleteDialog
    );
    const [deleteId, setDeleteId] = useState(null);
    const [rcmTeamData, setRcmTeamData] = useState<any>({});

    const {
        data: dependencies,
        isPending: isFetchingDependency,
        error: fetchingDependencyError,
    } = useData(async () => {
        if (!dialog?.open) return;
        const rcmTeam = await getRCMTeamDependencies(dialog?.rowData?.id);

        return rcmTeam;
    }, [dialog?.open]);

    const {
        data,
        isPending: isDeleting,
        error: deleteError,
    } = useData(async () => {
        if (!dialog?.open || !deleteId) return;
        const rcmTeam = await deleteRcmTeam({
            id: deleteId,
            updatedId: rcmTeamData?.name?.id || null,
        });
        setDeleteId(null);
        setRcmTeamData({});
        handleRefresh();
        handleClose();
        return rcmTeam;
    }, [deleteId]);

    useEffect(() => {
        if (!deleteError) return;
        setDeleteId(null);
        errorToastify(
            deleteError?.payload?.error ||
                "Something Went Wrong !! Please Contact Administrator"
        );
    }, [deleteError]);

    useEffect(() => {
        if (!fetchingDependencyError) return;
        errorToastify(
            fetchingDependencyError?.payload?.error ||
                "Something Went Wrong !! Please Contact Administrator"
        );
    }, [fetchingDependencyError]);

    return (
        <div>
            <DeleteConfirmation
                reducerName="rcmAssignment"
                stateName="rcmAssignmentDeleteDialog"
                defaultSelected={[]}
                handleDelete={(ids) => setDeleteId(ids[0])}
                customTitle={`Delete (${dialog?.rowData?.name})`}
                handleClose={() => {
                    setRcmTeamData({});
                    handleClose();
                }}
                isDeleting={isDeleting !== null}
                DELETE_TEXT={
                    dependencies?.records?.length > 0
                        ? "Following dependencies are found"
                        : `Are you sure you want to delete "${dialog?.rowData?.name}"`
                }
                isPending={isFetchingDependency !== null}
                defaultDeleteState={{
                    open: dialog?.open,
                    rowData: { id: dialog?.rowData?.id },
                }}
                canDelete={
                    dependencies?.canDelete ||
                    (!dependencies?.canDelete &&
                        Object.keys(rcmTeamData)?.length > 0)
                }
            >
                <DependentsList
                    dependents={dependencies?.records || []}
                    isSimpleDependency={true}
                />
                <br />
                {!dependencies?.canDelete && (
                    <>
                        <Typography>
                            {" "}
                            Bulk update all claims with this assignment to a
                            different RCM Team Assignment
                        </Typography>
                        <Autocomplete
                            disableClearable
                            value={rcmTeamData?.name || ""}
                            onChange={(e, option) => {
                                setRcmTeamData({ name: option });
                            }}
                            options={rcmAssignmentData?.filter((item)=>item?.id !=dialog?.rowData?.id) || []}
                            getOptionLabel={(option: any) =>
                                option?.name || option
                            }
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    required
                                    name={`Rcm Teams`}
                                    label="Rcm Teams"
                                    margin="normal"
                                />
                            )}
                        />
                    </>
                )}
            </DeleteConfirmation>
        </div>
    );
};

export default RcmDeleteDependencyDialog;
